import React, {useEffect, useState} from 'react';
import {InternalPageRoot, Message_Internal_Panel} from "../../../index";
import {Modules, ShowViewType} from "../../../config/AppConfig";
import {getCurrUrlParamValue} from "../../../../common/fusion-ui/utils/ReactUtils";

const Message_Internal_Page = React.memo(({
                                              open,
                                              onHide,
                                              showAs = ShowViewType.PAGE,
                                          }) => {
    const TAG = "Message_Internal_Page";
    const moduleName = Modules.Messages;

    const [recordId, setRecordId] = useState();

    useEffect(() => {
        const recordId = getCurrUrlParamValue('id');
        setRecordId(recordId);
    }, []);

    return (<>
            <InternalPageRoot
                tag={TAG}
                moduleName={moduleName}
                title={`Message Details`}
                backToListText={'Back to messages'}
                isDataFound={true}
                isDataLoading={false}
                showControls={false}
                open={open}
                onHide={onHide}
                showAs={showAs}>
                <Message_Internal_Panel
                    recordId={recordId}
                    fromPage={true}/>
            </InternalPageRoot>
        </>
    )
});
export default Message_Internal_Page;
